import supabase from '../../supabase/supabase';

/**
 * Helper to get browser timezone offset in ISO format (e.g. -07:00)
 */
const getTimezoneOffset = () => {
  const offset = new Date().getTimezoneOffset();
  const absOffset = Math.abs(offset);
  const hours = Math.floor(absOffset / 60);
  const minutes = absOffset % 60;
  const sign = offset > 0 ? "-" : "+";
  return `${sign}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};

/**
 * KIDS API
 */

export const getKids = async (householdId, userId) => {
  if (!householdId) return [];

  if (userId) {
    (async () => {
      try {
        // Pass the browser's timezone offset to the sync function
        const { error } = await supabase.rpc('sync_household_allowances', { 
          target_household_id: householdId,
          auth_user_id: userId,
          tz_offset: getTimezoneOffset()
        });
        if (error) console.error("Sync error:", error);
      } catch (e) {
        console.error("Network sync error:", e);
      }
    })();
  }

  const { data, error } = await supabase
    .from('kids_20240320')
    .select('*')
    .eq('household_id', householdId)
    .order('name');

  if (error) throw error;
  return data;
};

export const getKid = async (kidId, userId, householdId) => {
  if (userId && householdId) {
    (async () => {
      try {
        const { error } = await supabase.rpc('sync_household_allowances', { 
          target_household_id: householdId,
          auth_user_id: userId,
          tz_offset: getTimezoneOffset()
        });
        if (error) console.error("Sync error:", error);
      } catch (e) {
        console.error("Network sync error:", e);
      }
    })();
  }

  const { data, error } = await supabase
    .from('kids_20240320')
    .select('*')
    .eq('id', kidId)
    .single();

  if (error) throw error;
  return data;
};

export const addKid = async (householdId, kidData) => {
  const { data, error } = await supabase
    .from('kids_20240320')
    .insert({
      household_id: householdId,
      name: kidData.name,
      balance: kidData.balance || 0,
      allowance_amount: kidData.allowance_amount,
      allowance_interval: kidData.allowance_interval,
      allowance_day: kidData.allowance_day,
      allowance_time: kidData.allowance_time,
      last_allowance_paid_at: new Date().toISOString()
    })
    .select()
    .single();

  if (error) throw error;
  return data;
};

export const updateKid = async (kidId, updates) => {
  const { error } = await supabase
    .from('kids_20240320')
    .update(updates)
    .eq('id', kidId);
  if (error) throw error;
};

export const deleteKid = async (kidId) => {
  const { error } = await supabase
    .from('kids_20240320')
    .delete()
    .eq('id', kidId);
  if (error) throw error;
};

export const archiveKid = async (kidId) => {
  const { error } = await supabase
    .from('kids_20240320')
    .update({ is_archived: true })
    .eq('id', kidId);
  if (error) throw error;
};

export const unarchiveKid = async (kidId) => {
  const { error } = await supabase
    .from('kids_20240320')
    .update({ is_archived: false })
    .eq('id', kidId);
  if (error) throw error;
};